require("./my_careers_page_popup.coffee")
